export default "__VITE_ASSET__aba97d56__"